import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { EditLoanProvider } from './[loanId]/edit/useEditLoanContext';
import { permissions, editPermissions } from './permissions';
import { PermissionGuard } from '~/core/PermissionGuard';
import { Route as LoanRoute } from '~/core/routes/loans/[loanId]/_index';
import { Route as EditLoanRoute } from '~/core/routes/loans/[loanId]/edit/_index';
import { Route as EditLoanFundingRequestRoute } from '~/core/routes/loans/[loanId]/edit/fundingRequests/[fundingRequestId]/_index';
import { Route as ReviewLoanRoute } from '~/core/routes/loans/[loanId]/edit/review/_index';
import { Route as LoansRoute } from '~/core/routes/loans/_index';

// Exports
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /loans/*
  children: [
    { index: true, element: <LoansRoute /> },
    { path: ':loanId', element: <LoanRoute /> },
    {
      path: ':loanId/edit*',
      element: (
        <PermissionGuard permissions={editPermissions}>
          <EditLoanProvider>
            <Outlet />
          </EditLoanProvider>
        </PermissionGuard>
      ),
      children: [
        { index: true, element: <EditLoanRoute /> },
        {
          path: 'fundingRequests/:fundingRequestId',
          element: <EditLoanFundingRequestRoute />,
        },
        { path: 'review', element: <ReviewLoanRoute /> },
      ],
    },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
